// extracted by mini-css-extract-plugin
export default {"wrapper":"EditTeamTeamLead_wrapper__3QQee","form":"EditTeamTeamLead_form__2xjZI","dimmer":"EditTeamTeamLead_dimmer__M5uKN"};